import { jsx, jsxs } from "react/jsx-runtime";
import { useDelayGroupContext } from "@floating-ui/react";
import { Paragraph } from "@tamagui/text";
import { Tooltip, TooltipGroup } from "./Tooltip";
const TooltipSimple = ({
  label,
  children,
  contentProps,
  ...tooltipProps
}) => {
  let context;
  try {
    context = useDelayGroupContext();
  } catch {
  }
  const contents = /* @__PURE__ */ jsxs(Tooltip, { ...tooltipProps, children: [
    /* @__PURE__ */ jsx(Tooltip.Trigger, { asChild: true, children }),
    /* @__PURE__ */ jsxs(
      Tooltip.Content,
      {
        zIndex: 1e9,
        enterStyle: { x: 0, y: -8, opacity: 0, scale: 0.93 },
        exitStyle: { x: 0, y: -8, opacity: 0, scale: 0.93 },
        x: 0,
        scale: 1,
        y: 0,
        elevation: "$1",
        opacity: 1,
        animation: [
          "quick",
          {
            opacity: {
              overshootClamping: true
            }
          }
        ],
        ...contentProps,
        children: [
          /* @__PURE__ */ jsx(Tooltip.Arrow, {}),
          /* @__PURE__ */ jsx(Paragraph, { size: "$2", lineHeight: "$0", children: label })
        ]
      }
    )
  ] });
  if (!context) {
    return /* @__PURE__ */ jsx(TooltipGroup, { delay: defaultTooltipDelay, children: contents });
  }
  return contents;
};
const defaultTooltipDelay = { open: 3e3, close: 100 };
export {
  TooltipSimple
};
//# sourceMappingURL=TooltipSimple.js.map
